import {Injectable} from "@angular/core";
import {AppSettings, AuthorizationHelperService, GlobalService, HttpServiceBase} from "@nordpoolgroup/nps-angular-2-common";
import {Http} from "@angular/http";
import "rxjs/add/operator/toPromise";

@Injectable()
export class AreaDomainService extends HttpServiceBase implements NPS.Common.IHttpServiceBase {

    constructor(
        http: Http,
        globalService: GlobalService,
        authorizationHelperService: AuthorizationHelperService
    ) {
        super(
            http,
            globalService,
            authorizationHelperService,
            "",
            AppSettings.systemConfiguration.ApiAddress
        );
    }

    get(): Promise<NPS.AreaDomain.IAreaDomain[]> {
        return super.get<NPS.AreaDomain.IAreaDomain[]>("tradingAreas");
    }

    getByTenantIdAndMarketType(tenantId: string, marketType: string): Promise<NPS.AreaDomain.IAreaDomain[]> {
        return super.get<NPS.AreaDomain.IAreaDomain[]>("tradingAreas/" + tenantId + "/" + marketType);
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/Services/AreaDomainService.ts